import { defineStore } from 'pinia';

export const useConfirmStore = defineStore('coveConfirm', {
  state () {
    return {
      visible: false,
      message: null,
      subtitleKey: null,
      typingPromptKey: null,
      resolve: null,
      width: null
    };
  },
  actions: {
    show (payload) {
      return new Promise((resolve) => {
        this.$patch({
          ...payload,
          resolve,
          visible: true
        });
      });
    },
    close (value) {
      this.$patch({ visible: false });
      this.resolve(value);
    }
  }
});